import { DetailedVehicle } from "Api/registration";
import React from "react";
import { STOREBRAND_COMPANY_CODE } from "../hooks";

export const MetaInformation = (props: {
  vehicle: DetailedVehicle & { isAddedToCart: boolean };
}): JSX.Element => {
  const { vehicle } = props;

  if (vehicle.isAddedToCart) {
    return <span>I handlekurven</span>;
  }

  if (vehicle.companyCode === STOREBRAND_COMPANY_CODE) {
    return <span>Forsikret hos Storebrand</span>;
  }

  return <span>Forsikret hos {vehicle.companyName}</span>;
};
